import { render, staticRenderFns } from "./CrearProveedorModal.vue?vue&type=template&id=13643ec9&"
import script from "./CrearProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./CrearProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('13643ec9', component.options)
    } else {
      api.reload('13643ec9', component.options)
    }
    module.hot.accept("./CrearProveedorModal.vue?vue&type=template&id=13643ec9&", function () {
      api.rerender('13643ec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedor/CrearProveedorModal.vue"
export default component.exports